/**
 * TransactionStatusService
 * Service for TransactionStatus entity operations
 * Route: api/transaction-status
 * Controller: TransactionStatusController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * TransactionStatusService
 * Handles transaction status CRUD operations
 * Maps to /api/transaction-status endpoint
 */
export class TransactionStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TransactionStatusService.DEFAULT_SERVICE_PATH,
            basePath: TransactionStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate transaction status cache
     * POST /api/transaction-status/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate transaction status cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
TransactionStatusService.DEFAULT_SERVICE_PATH = 'payments';
TransactionStatusService.BASE_PATH = 'api/transaction-status';
//# sourceMappingURL=TransactionStatusService.js.map